<template lang="pug">
  v-toolbar(color="toolbar", clipped-left, flat, style="padding-right: 0;" fixed)
    v-toolbar-title
      v-layout(justify-start align-center)
        img(src="/static/Logo_Stat.svg" alt="логотип статистического коммитета" class="pa-1 img-title")
        div(class="white--text text-capitalize subheading pl-2").text-title {{$t('StartPage.registerBlock.test')}}
    v-spacer
    v-toolbar-items
      Search(v-if="isAdmin")
      UserInfo
      Logout
</template>

<script>
import Search from './Search'
export default {
  name: 'ToolBar',
  components: {
    Search,
    Logout: () => import('./Logout'),
    UserInfo: () => import('./UserInfo')
  },
  computed: {
    isAdmin() {
      return this.$store.state.profile.isAdmin
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainPage/common/ToolBar.vue